<template>
	<div>
		<el-header>
			<el-dialog title="添加评价设置" :visible.sync="saveWorkCommentShow" width="30%">
				<el-form>
					<el-form-item label="评价描述" label-width="100px">
						<el-input v-model="workerComment.name"></el-input>
					</el-form-item>
					<el-form-item label="评价星级" label-width="100px">
						<el-input v-model="workerComment.score"></el-input>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="saveWorkCommentShow = false">取 消</el-button>
					<el-button type="primary" @click="saveComment">确 定</el-button>
				</div>
			</el-dialog>
			<el-dialog title="添加等级设置" :visible.sync="saveLevelShow" width="30%">
				<el-form>
					<el-form-item label="等级描述" label-width="100px">
						<el-input v-model="level.title"></el-input>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="saveLevelShow = false">取 消</el-button>
					<el-button type="primary" @click="saveLevel">确 定</el-button>
				</div>
			</el-dialog>
			<el-row :gutter="24">
				<el-col :span="4">
					<div>
						<b>发型师评价</b>
					</div>
					<div style="margin-top:30px">
						评价设置
						<span style="margin-left:100px">评价描述</span>
					</div>
				</el-col>
				<el-col :span="7" style="margin-top:50px">
					<div style="margin-right:30px; border:1px soild black;">
						<div style="margin-bottom: 15px; position: relative" v-for="item in workerComments"
							:key="item.id">
							<el-input v-model="item.name"></el-input>
							<i class="el-icon-remove" style="position: absolute; top:10px; right:-30px"
								@click="delComment(item.id)"></i>
						</div>
						<div>
							<el-button @click="saveWorkCommentShow=true">添加</el-button>
							<el-button @click="editComment">保存</el-button>
						</div>
					</div>
				</el-col>
				<el-col :span="4">
					<div>
						<b>发型师等级</b>
					</div>
					<div style="margin-top:30px">
						等级设置
						<span style="margin-left:100px">等级描述</span>
					</div>
				</el-col>
				<el-col :span="7" style="margin-top:50px">
					<div>
						<div style="margin-bottom:15px; position: relative">
							<div style="margin-bottom: 15px; position: relative" v-for="item in levels" :key="item.id">
								<el-input v-model="item.title"></el-input>
								<i class="el-icon-remove" style="position: absolute; top:10px; right:-30px"
									@click="delLevel(item.id)"></i>
							</div>
						</div>
						<div>
							<el-button @click="saveLevelShow=true">添加</el-button>
						</div>
					</div>
				</el-col>
			</el-row>
		</el-header>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				saveWorkCommentShow: false,
				saveLevelShow: false,
				workerComment: {
					name: undefined,
					score: undefined,
				},
				level: {
					title: undefined,
				},
				workerComments: [],
				levels: [],
				tableData: [],
			};
		},
		methods: {
			getWorkerComment() {
				this.$http.get("workerComment/list").then(res => {
					this.workerComments = res.body.data
				})
			},
			getLevels() {
				this.$http.get("dWorkerLevel/query").then(res => {
					this.levels = res.body.data
				})
			},
			saveLevel() {
				let data = JSON.stringify(this.level)
				this.$http.post("dWorkerLevel/save", data).then(res => {
					if (res.body.code == 200) {
						this.saveLevelShow = false;
						this.getLevels();
						this.level = {
							title: undefined,
						};
					} else {
						this.$message.error(res.body.msg)
					}
				})
			},
			saveComment() {
				let data = JSON.stringify(this.workerComment)
				this.$http.post("workerComment/save", data).then(res => {
					if (res.body.code == 200) {
						this.saveLevelShow = false;
						this.getWorkerComment();
						workerComment = {
							name: undefined,
							score: undefined,
						};
					} else {
						this.$message.error(res.body.msg)
					}
				})
			},
			delComment(id) {
				this.$http.post("workerComment/del/" + id).then(res => {
					if (res.body.code == 200) {
						this.getWorkerComment();
						this.$message.success("删除成功");
					} else {
						this.$message.error(res.body.msg)
					}
				})
			},
			delLevel(id) {
				this.$http.post("dWorkerLevel/del/" + id).then(res => {
					if (res.body.code == 200) {
						this.getLevels();
						this.$message.success("删除成功");
					} else {
						this.$message.error(res.body.msg)
					}
				})
			},
			editComment() {
				let data = JSON.stringify(this.workerComments)
				this.$http.post("workerComment/edit", data).then(res => {
					if (res.body.code == 200) {
						this.getWorkerComment();
					} else {
						this.$message.error(res.body.msg)
					}
				})
			}
		},
		// 初始化
		mounted() {
			this.getWorkerComment();
			this.getLevels();
		}
	};
</script>

<style>

</style>